import { render, staticRenderFns } from "./enFooter.vue?vue&type=template&id=361b143e&"
import script from "./enFooter.vue?vue&type=script&lang=js&"
export * from "./enFooter.vue?vue&type=script&lang=js&"
import style0 from "./enFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports